import { productPriceStyles } from "@insite/content-library/Components/ProductPrice";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(productPriceStyles, {
    price: {
        priceText: {
            weight: "bold",
            css: css`
                letter-spacing: ${TYPOGRAPHY.letterSpacing.large};
            `,
        },
    },
});
